module.exports = __webpack_public_path__ + "img/logo-clearmortgagecapital-big.1cf50522.svg";